import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Menu, X, LibraryBig, Clock, Star, Plus, Tags, LineChart,
} from 'lucide-react';
import { usePermission } from '../../../context/PermissionContext';

const SopSidebar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { hasPermission } = usePermission();

  const canAuthor = hasPermission('ksp_sops_author') || hasPermission('ksp_sops_manage');
  const canManage = hasPermission('ksp_sops_manage');

  const sections = [
    {
      category: 'Library',
      items: [
        { name: 'All SOPs', path: '/tiles/ksp_sops/library', icon: <LibraryBig className="w-5 h-5" /> },
        { name: 'Recently Viewed', path: '/tiles/ksp_sops/recent', icon: <Clock className="w-5 h-5" /> },
        { name: 'Favorites', path: '/tiles/ksp_sops/favorites', icon: <Star className="w-5 h-5" /> },
      ],
    },
  ];

  if (canAuthor) {
    sections.push({
      category: 'Authoring',
      items: [{ name: 'New SOP', path: '/tiles/ksp_sops/new', icon: <Plus className="w-5 h-5" /> }],
    });
  }

  if (canManage) {
    sections.push({
      category: 'Administration',
      items: [
        { name: 'Tag Manager', path: '/tiles/ksp_sops/admin/tags', icon: <Tags className="w-5 h-5" /> },
        { name: 'Search Insights', path: '/tiles/ksp_sops/admin/insights', icon: <LineChart className="w-5 h-5" /> },
      ],
    });
  }

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <>
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-slate-800 text-slate-200"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle navigation"
      >
        {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <div
        className={`fixed inset-y-0 left-0 z-40 transition-transform duration-300 transform
          ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
          h-screen bg-slate-800 border-r border-slate-700 w-64 overflow-y-auto`}
      >
        <div className="p-4 border-b border-slate-700/50">
          <Link
            to="/"
            className="flex items-center px-4 py-2 text-sm text-slate-300 hover:bg-slate-700/50 hover:text-slate-100 rounded-md"
          >
            <span className="mr-3">←</span>
            <span>Back to HQ</span>
          </Link>
        </div>

        <nav className="mt-4">
          {sections.map((section) => (
            <div key={section.category} className="mb-6">
              <h3 className="px-4 mb-2 text-xs font-semibold text-slate-400 uppercase tracking-wider">
                {section.category}
              </h3>
              <div>
                {section.items.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center px-4 py-2 text-sm ${
                      isActive(item.path)
                        ? 'bg-indigo-600 text-white'
                        : 'text-slate-300 hover:bg-slate-700/50 hover:text-slate-100'
                    }`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <span className="mr-3">{item.icon}</span>
                    <span>{item.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>
    </>
  );
};

export default SopSidebar;
